import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {useHydrateThreadPositioning} from '../../hooks/use-hydrate-thread-positioning'

export function HydrateThreadPositioning({threads}: {threads: Thread[]}) {
  useHydrateThreadPositioning(threads)
  return null
}
